var styleDataHash = 'cf69e93d';  
export const injectCss = (() => {
  var css = `.SMYW9{position:absolute;right:6px;top:0}._9VlZI{height:18px;margin:6px;width:18px}.b3YVf{height:24px;margin:3px;width:24px}.orUJ1{position:relative}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "statusIndicator": "SMYW9",
  "statusIndicatorLoader": "_9VlZI",
  "statusIndicatorWarning": "b3YVf",
  "inputWrapper": "orUJ1"
};